/*
 * PROD-7828 — the module's tab list, kept I/O-free so the shell and the badge adapter can be pinned
 * to the same keys (D32 deleted "Session review"; a badge for a tab that is gone is invisible).
 * `hidden` tabs are routable (/teacher-payments/<key>) but not in the tab bar (R10-C15).
 */
export const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'needs-attention', label: 'Needs attention' },
  { key: 'penalties', label: 'Penalties' },
  { key: 'additional-payments', label: 'Additional payments' },
  { key: 'reports', label: 'Reports' },
  { key: 'close-versions', label: 'Close versions' },
  { key: 'email-logs', label: 'Email logs', release: 'R11' },
  { key: 'audit', label: 'Audit trail', hidden: true },
  { key: 'rules', label: 'Calculation rules', hidden: true }
];

export const TAB_KEYS = TABS.map((t) => t.key);

// The tabs that read a real month; the stubs do not.
export const MONTH_TABS = [
  'overview',
  'needs-attention',
  'penalties',
  'additional-payments',
  'reports',
  'close-versions'
];

// CD-197: no header month picker here; the rules have no month and the audit trail filters its own.
export const NO_MONTH_PICKER_TABS = ['audit', 'rules'];

// The built tabs of the tab bar, which a stub names as live.
export const LIVE_TAB_LABELS = TABS.filter((t) => !t.release && !t.hidden).map((t) => t.label);
